import * as tslib_1 from "tslib";
import { SearchesCommon } from '../searches.common';
import { DowJones2DetailComponent } from '../components/searches-detail/dow-jones2-detail/dow-jones2-detail.component';
var SearchesDj2Component = /** @class */ (function (_super) {
    tslib_1.__extends(SearchesDj2Component, _super);
    function SearchesDj2Component() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isActive = 'country_details';
        _this.displayedColumns = [
            'checkbox', 'person_name_details', 'country_details',
            'date_details', 'gender', 'watchlist_content', 'score', 'options', 'matched'
        ];
        return _this;
    }
    SearchesDj2Component.prototype.selectDetail = function (item) {
        this.dialogRefDJ2 = this.dialog.open(DowJones2DetailComponent, {
            data: tslib_1.__assign({}, item, { scanType: this.type, recordType: this.recordType }),
            autoFocus: false, width: '1300px'
        });
    };
    return SearchesDj2Component;
}(SearchesCommon));
export { SearchesDj2Component };
